import { jwtDecode } from "jwt-decode";
import { refreshTokens } from "@/shared/auth/services/refreshTokens.service";
import { getAuthTokensFromCookie } from "./authTokensCookie.helper";

export const getActiveTokens = async () => {
  const tokens = getAuthTokensFromCookie();
  if (!tokens?.idToken) return undefined;

  const decodedIdToken = jwtDecode(tokens.idToken);
  if (!decodedIdToken.exp) return tokens;

  const expiresAt = new Date(decodedIdToken.exp * 1000);
  const now = new Date(Date.now());

  if (expiresAt < now) {
    const aud = decodedIdToken.aud;
    const clientId = Array.isArray(aud) ? aud[0] : aud;
    return clientId ? await refreshTokens(clientId) : undefined;
  }

  return tokens;
};
